// Module-level register for Ops Lookup selection (slider + focused row ids).
// Read by `bugReportPayload.ts` so admin-beta bug reports carry enough
// context to triage without asking "which sale/order/service?".
//
// Intentionally omits the search query (may contain customer names / PII).

import type { OpsLookupSlider } from "@/lib/opsLookup/opsLookupModel";

export type OpsLookupFocusSnapshot = {
  slider: OpsLookupSlider;
  selected_sale_id: string | null;
  selected_order_id: string | null;
  selected_service_id: string | null;
};

let _focus: OpsLookupFocusSnapshot | null = null;

export function setOpsLookupFocus(focus: OpsLookupFocusSnapshot | null): void {
  _focus = focus;
}

export function clearOpsLookupFocus(): void {
  _focus = null;
}

export function readOpsLookupFocus(): OpsLookupFocusSnapshot | null {
  return _focus;
}

/** Test-only — resets singleton state between runs. */
export function __resetOpsLookupFocusForTests(): void {
  _focus = null;
}
